/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} System_Status_Summary_UnavailableInputs */



/**
* | output |
* | --- |
* | "oneAI is currently unavailable — our team is on it." |
*
* @param {System_Status_Summary_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const system_status_summary_unavailable = /** @type {((inputs?: System_Status_Summary_UnavailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<System_Status_Summary_UnavailableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("oneAI ist derzeit nicht verfügbar – unser Team kümmert sich darum.")
	return /** @type {LocalizedString} */ ("oneAI is currently unavailable — our team is on it.")
});